<template>
  <div>
    <div
      class="d-flex flex-column pt-12 bgi-size-cover bgi-no-repeat rounded-top"
      :style="{ backgroundImage: `url(${backgroundImage})` }"
    >
      <h4 class="d-flex flex-center rounded-top">
        <span class="text-white">User Notifications</span>
        <!-- <span
          class="
            btn btn-text btn-success btn-sm
            font-weight-bold
            btn-font-md
            ml-2
          "
        >
          {{ data.length +  messages.length }} new
        </span> -->
      </h4>

      <ul
        class="nav nav-bold nav-tabs nav-tabs-line nav-tabs-line-3x nav-tabs-line-transparent-white nav-tabs-line-active-border-success mt-3 px-8"
        role="tablist"
      >
        <li class="nav-item">
          <a
            v-on:click="setActiveTab"
            data-tab="0"
            class="nav-link active"
            data-toggle="tab"
            href="#"
            role="tab"
          >
            Messages
            <sup class="text-white" v-if="message_notify_count > 0">{{
              message_notify_count
            }}</sup>
          </a>
        </li>
        <li class="nav-item" v-if="jobSeeker">
          <a
            v-on:click="setActiveTab"
            data-tab="1"
            class="nav-link"
            data-toggle="tab"
            href="#"
            role="tab"
          >
            New Jobs
            <sup class="text-white" v-if="new_jobs_notify_count > 0">{{
              new_jobs_notify_count
            }}</sup>
          </a>
        </li>
        <li class="nav-item" v-if="recruiter">
          <a
            v-on:click="setActiveTab"
            data-tab="1"
            class="nav-link"
            data-toggle="tab"
            href="#"
            role="tab"
          >
            Job Applications
            <sup class="text-white" v-if="job_apps_notify_count > 0">{{
              job_apps_notify_count
            }}</sup>
          </a>
        </li>
      </ul>
    </div>

    <b-tabs class="hide-tabs" v-model="tabIndex">
      <b-tab active>
        <perfect-scrollbar
          class="navi navi-hover scroll my-4"
          style="max-height: 40vh; position: relative"
        >
          <template v-for="(item, i) in messages">
            <a
              href="#"
              class="navi-item"
              v-bind:key="i"
              @click="msg_notification_read(item.id)"
            >
              <div class="navi-link">
                <div class="navi-text">
                  <div class="font-weight-bold">
                    {{ item.sender_name }} sent a personal message in
                    {{ item.job_title }} conversation
                  </div>
                </div>
              </div>
            </a>
          </template>
        </perfect-scrollbar>
      </b-tab>

      <b-tab class="p-8" v-if="jobSeeker">
        <perfect-scrollbar
          class="scroll pr-7 mr-n7"
          style="max-height: 40vh; position: relative"
        >
          <template v-for="(item, i) in data">
            <!--begin::Item-->
            <div class="d-flex align-items-center mb-6" v-bind:key="i">
              <!--begin::Symbol-->
              <div
                class="symbol symbol-40 mr-5"
                v-bind:class="`symbol-light-primary`"
              >
                <span class="symbol-label">
                  <img
                    style="width: 25px"
                    :src="mediaUrl + item.recruiter.profile_pic"
                    class="h-15 align-self-center"
                    alt=""
                  />
                </span>
              </div>
              <!--end::Symbol-->
              <!--begin::Text-->
              <div class="d-flex flex-column font-weight-bold">
                <router-link
                  :to="
                    '/employer/' +
                    item.recruiter.company_name
                      .toLowerCase()
                      .replace(/ /g, '-') +
                    '/' +
                    item.recruiter.id
                  "
                  target="_blank"
                >
                  <span class="font-weight-bolder">{{
                    item.recruiter.company_name
                  }}</span>
                </router-link>
                <span class="text-muted">
                  <router-link
                    :to="
                      '/jobs-careers/pakistan/' +
                      item.job.location_city
                        .map((v) => v.toLowerCase())
                        .join('-') +
                      '/' +
                      item.job.job_title
                        .toLowerCase()
                        .replace(/ /g, '-')
                        .replace(/[^\w-]+/g, '') +
                      '/' +
                      item.id
                    "
                    target="_blank"
                  >
                    {{ item.job.job_title }}
                  </router-link>
                </span>
              </div>

              <p class="text-muted" style="margin-left: 10%">
                {{ item.job.salary_min }} - {{ item.job.salary_max }}
              </p>

              <a
                class="btn btn-icon btn-light btn-sm"
                style="margin-right: 3%"
                @click.prevent="viewJob(item.job, item.id)"
              >
                <span class="svg-icon svg-icon-md svg-icon-primary">
                  <!--begin::Svg Icon-->
                  <inline-svg
                    src="media/svg/icons/General/Visible.svg"
                  ></inline-svg>
                  <!--end::Svg Icon-->
                </span>
              </a>
              <a
                @click.prevent="read(item.id)"
                class="btn btn-icon btn-light btn-sm"
              >
                <span class="svg-icon svg-icon-md svg-icon-primary">
                  <!--begin::Svg Icon-->
                  <inline-svg
                    src="media/svg/icons/General/Trash.svg"
                  ></inline-svg>
                  <!--end::Svg Icon-->
                </span>
              </a>
              <!--end::Text-->
            </div>
            <!--end::Item-->
          </template>
        </perfect-scrollbar>
      </b-tab>

      <b-tab class="p-8" v-if="recruiter">
        <perfect-scrollbar
          class="scroll pr-7 mr-n7"
          style="max-height: 40vh; position: relative"
        >
          <!-- {{ jobApplications }} -->
          <template v-for="(item, i) in app_notifications">
            <!--begin::Item-->
            <div
              class="d-flex align-items-center mb-6"
              v-bind:key="i"
              :class="item.seen_at == NULL ? 'bg-secondary' : 'bg-white'"
            >
              <a
                :href="
                  '/recruiter/job-applications#jobseeker_app_' +
                  item.job_seeker_name
                    .toLowerCase()
                    .replace(/ /g, '-')
                    .replace(/[^\w-]+/g, '') +
                  '_' +
                  item.job_title
                    .toLowerCase()
                    .replace(/ /g, '-')
                    .replace(/[^\w-]+/g, '')
                "
                @click="notification_read(item.id)"
                >{{ item.job_seeker_name }} has applied for the post of
                {{ item.job_title }}
              </a>
              <hr />
              <!--begin::Symbol-->
              <!-- <div
                class="symbol symbol-40 mr-5"
                v-bind:class="`symbol-light-primary`"
              >
                <span class="symbol-label">
                  <img
                    style="width: 25px"
                    :src="mediaUrl + item.job_seeker_profile.profile_pic"
                    class="h-75 align-self-end"
                    alt=""
                  />
                </span>
              </div> -->
              <!--end::Symbol-->
              <!--begin::Text-->
              <!-- <div class="d-flex flex-column font-weight-bold">
                <span class="font-weight-bolder">
                </span>
                <span class="text-muted">
                  {{ item.job_seeker_profile.profession }}
                </span>
              </div> -->

              <!-- <p class="text-muted" style="margin-left: 10%">
                {{ item.job.salary_min }} - {{ item.job.salary_max }}
              </p> -->

              <!-- <a
                :href="'/recruiter/job-application-detail/' + item.id"
                class="btn btn-light-success font-weight-bolder font-size-sm"
              >
                View application
              </a> -->
              <!--end::Text-->
            </div>
            <!--end::Item-->
          </template>
        </perfect-scrollbar>
      </b-tab>
    </b-tabs>
  </div>
</template>

<style lang="scss">
/* hide default vue-bootstrap tab links */
.hide-tabs > div:not(.tab-content) {
  display: none;
}
</style>

<script>
import axios from "axios";
import { API_URL, MEDIA_URL } from "@/core/api";
import moment from "moment";
export default {
  name: "KTDropdownNotification",
  data() {
    return {
      jobSeeker:
        JSON.parse(localStorage.getItem("user")).role == "Job Seeker"
          ? true
          : false,
      recruiter:
        JSON.parse(localStorage.getItem("user")).role == "Direct Employer"
          ? true
          : false,
      tabIndex: 0,
      app_notifications: [],
      data: JSON.parse(localStorage.getItem("followupJobs")),
      messages: [],
      jobApplications: JSON.parse(localStorage.getItem("jobApplications")),
      mediaUrl: MEDIA_URL,
      token: `Bearer ${localStorage.getItem("token")}`,
      message_notify_count: 0,
      job_apps_notify_count: 0,
      new_jobs_notify_count: 0,
    };
  },
  methods: {
    notification_read(id) {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios.post(`${API_URL}/notifications-read`, { id: id }).then((res) => {
        window.location.reload();
      });
    },
    msg_notification_read(id) {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .post(`${API_URL}/msg-notifications-read`, { id: id })
        .then((res) => {
          window.location = "/recruiter/job-applications";
        });
    },
    moment: function () {
      return moment();
    },
    setActiveTab(event) {
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set clicked tab index to bootstrap tab
      this.tabIndex = parseInt(event.target.getAttribute("data-tab"));

      // set current active tab
      event.target.classList.add("active");
    },
    viewJob(item, id) {
      this.read(id);
      this.$router.push({
        path:
          "/jobs-careers/pakistan/" +
          item.location_city.map((v) => v.toLowerCase()).join("-") +
          "/" +
          item.job_title
            .toLowerCase()
            .replace(/ /g, "-")
            .replace(/[^\w-]+/g, "") +
          "/" +
          item.id,
        params: {
          search_text: this.search_text,
          selected_cities: [{ id: 1, value: item }],
        },
      });
    },
    read(id) {
      axios
        .get(`${API_URL}/read-company-watch-list-alert/${id}`)
        .then((res) => {
          this.fetch();
        });
    },
  },
  computed: {
    backgroundImage() {
      return process.env.BASE_URL + "media/misc/bg-1.jpg";
    },
  },

  mounted() {
    axios.defaults.headers.common["Authorization"] = this.token;
    axios.get(`${API_URL}/get-all-notifications`).then((res) => {
      if (res.data.app_notifications.length > 0 && res.data.job != null) {
        res.data.app_notifications.map((el) => {
          this.app_notifications.push({
            id: el.id,
            job_seeker_name: el.job_seeker.name,
            job_title: el.job_application.job.job_title,
            seen_at: el.seen_at,
          });
        });
      }

      if (res.data.msg_notifications.length > 0) {
        res.data.msg_notifications.map((el) => {
          this.messages.push({
            id: el.id,
            sender_name: el.sender_name,
            job_title: el.job_title,
          });
        });
      }

      this.message_notify_count = res.data.msg_notifications_num;
      this.job_apps_notify_count = res.data.app_notifications_num;
    });

    window.Echo.channel("job_applied_channel").listen(
      "JobAppliedNotification",
      (e) => {
        // if(e.auth_user_id == e.data.recruiter_id)
        if (e.auth_user_id == e.data.recruiter_id) {
          this.job_apps_notify_count = e.notifications_num;
          this.app_notifications.splice(0, 0, e);
          // this.app_notifications.push(e);
        }
      }
    );

    window.Echo.channel("channel").listen("Notifications", (e) => {
      this.messages.splice(0, 0, {
        id: e.msg_id,
        sender_name: e.sender_name,
        job_title: e.job_title,
      });
      this.message_notify_count = e.total_unclick;
    });
  },
};
</script>
